import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { OverflowTooltipDirective } from '@uigy/shared/directives/overflow-tooltip.directive';
import { UiStackedProgressBarSegment } from '@uigy/shared/components/ui-progress-bar/ui-stacked-progress-bar.interfaces';

@Component({
  selector: 'app-ui-stacked-progress-bar',
  imports: [
    MatTooltip,
  ],
  templateUrl: './ui-stacked-progress-bar.component.html',
  styleUrls: ['./ui-stacked-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiStackedProgressBarComponent {
  /**
   * Up to 10 data sources that will be split proportionally across the bar.
   * The order of the array determines the visual order from left to right.
   */
  public segments = input<UiStackedProgressBarSegment[]>([]);

  /** Height of the bar in pixels */
  public height = input<number>(8);

  /**
   * Segments filtered for valid positive numeric values.
   */
  protected filteredSegments = computed<UiStackedProgressBarSegment[]>(() => {
    const segments = this.segments() ?? [];

    return segments
      .filter((segment) => segment && typeof segment.value === 'number' && segment.value > 0);
  });

  /** Total of all segment values (used for proportional widths and default label) */
  protected totalValue = computed<number>(() =>
    this.filteredSegments().reduce((sum, segment) => sum + segment.value, 0),
  );

  protected normalizedSegments = computed<(UiStackedProgressBarSegment & { percentage: number })[]>(
    () => {
      const total = this.totalValue();
      const segments = this.filteredSegments();

      if (!total) {
        return [];
      }

      return segments.map((segment) => ({
        ...segment,
        percentage: (segment.value / total) * 100,
      }));
    },
  );
}

